import { render, staticRenderFns } from "./LeavingNoticeView.vue?vue&type=template&id=59a0bc7c&"
import script from "./LeavingNoticeView.vue?vue&type=script&lang=ts&"
export * from "./LeavingNoticeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports